<i class="material-icons" [ngClass]="optedIn ? 'opted-in' : 'opted-out'">{{ optedIn ? 'check' : 'close' }}</i>
<span class="opt-text">{{ optedIn ? 'Opted-in' : 'Opted-out' }}</span>
